m = require 'mithril'

Hand 		= require '../../lib/Hand'
CommonViews = require './CommonViews'

# HACK: Don't require c3 until it's needed, to give it a chance to have loaded
c3 = null

GameChart = {
	controller: () ->
		c3 = require 'c3'

	view: (ctrl, args) ->
		game = args.game

		m '.gamechart', {config: (args...) -> drawChart game, args...}
}

drawChart = (game, element, isInitialised, context) ->
	totals = (accs, currentRound, currentIndex) ->

	data = game.players.map (player) -> [
		player.name
		game.rounds.reduce(((acc, round, i) ->
			prevTotal = acc[i]
			acc[i+1] = prevTotal + Hand.GetTotal round[player.id]
			acc
		), [0])...
	]

	if not isInitialised
		context.chart = c3.generate {
			bindto: element
			data: {
				columns: data
			}
		}
	else
		context.chart.load {
			unload: true
			columns: data
		}

module.exports = GameChart